module.exports = __webpack_public_path__ + "images/general_car.svg";